import { InjectionToken } from '@angular/core';

import { AuthPanelService } from './auth-panel-service.interface';

export const AUTH_PANEL_SERVICE = new InjectionToken<AuthPanelService>('Auth Panel Service');
